<template>
    <div class="overflow-x-hidden">
        <section
            class="testimonials-section grid flex flex-wrap justify-content-center align-items-center py-6 md:px-8 relative">
             <img 
                src="@/assets/Images/trees.png" 
                alt=""
               class="testimonials-decoration"
            >
            <div class="container px-4 md:px-6 relative" style="z-index: 2;">
                <div class="text-center mb-6">
                    <span class="badge mb-2">{{badgeTitle}}</span>
                    <h2 class="LandingPage-Title mb-2">{{title}}</h2>
                    <p class="Paragraph-Regular mx-auto">
                        Don't just take our word for it. Here's what students across Sri Lanka have to say about their
                        learning experience with TeachLanka.
                    </p>
                </div>

                <!-- Testimonials Carousel -->
                <div class="testimonials-carousel">
                    <Carousel :value="testimonials" :numVisible="1" :numScroll="1" circular :autoplayInterval="3000"
                        :responsiveOptions="carouselResponsiveOptions">
                        <template #item="slotProps">
                            <div
                                class="testimonial-card flex flex-column grid md:col-8 md:px-6 md:py-8 border-round-xl text-center">
                                <div class="student-info mb-4 ">
                                    <div class="flex align-items-center justify-content-center gap-3 mb-2">
                                        <Avatar :image="slotProps.data.avatar || blankProfile" size="large" shape="circle" />
                                        <div class="text-left">
                                            <p class="H6-Medium mb-1">{{ slotProps.data.name }}</p>
                                            <p class=" Paragraph-Medium text-white mt-0 ">{{ slotProps.data.location }}</p>
                                        </div>
                                    </div>
                                    <div class="flex justify-content-center gap-1 mb-2 align-self-start">
                                        <i v-for="n in 5" :key="n" class="pi pi-star-fill text-yellow-500"></i>
                                    </div>
                                </div>
                                <p class="Paragraph-Regular leading-relaxed">
                                    "{{ slotProps.data.testimonial }}"
                                </p>
                            </div>
                        </template>
                    </Carousel>
                </div>
            </div>
        </section>
    </div>
</template>
<script setup>
import { defineProps } from 'vue';
import Carousel from 'primevue/carousel';
import Avatar from 'primevue/avatar';
import blankProfile from '@/assets/blank-profile.png';
defineProps({
    testimonials: null,
    title:String,
    badgeTitle:String


});
</script>

<style scoped>
/* Testimonials Section */
.testimonials-section {
    background-color: #77BFD0;
    position: relative;
    overflow: hidden; 
}

.testimonial-card {
    background: transparent;
    margin: 0 auto;
    border: 2px solid white;
}

:deep(.p-carousel .p-carousel-indicators) {
    padding: 1rem 0;
}

:deep(.p-carousel .p-carousel-indicator button) {
    background-color: #cbd5e1;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    transition: all 0.3s ease;
}

:deep(.p-carousel .p-carousel-indicator.p-highlight button) {
    background-color: #3b82f6;
    width: 30px;
    border-radius: 6px;
}
.testimonials-decoration {
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 1;
    width: 300px;
    height: 300px;
    object-fit: contain;
}

/* Responsive styles */
@media (max-width: 768px) {
    .testimonials-decoration {
        width: 200px;
        height: 200px;
    }
}

@media (max-width: 480px) {
    .testimonials-decoration {
        width: 150px;
        height: 150px;
    }
}
</style>